import { ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react';

interface StepNavigationProps {
  activeStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrevious: () => void;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({ activeStep, totalSteps, onNext, onPrevious }) => {
  const isFirstStep = activeStep === 0;
  const isLastStep = activeStep === totalSteps - 1;

  console.log('[StepNavigation] Rendering navigation:', {
    activeStep,
    totalSteps,
    isFirstStep,
    isLastStep,
  });

  return (
    <div className="flex items-center justify-between mt-6 pt-6 border-t border-slate-200">
      <button
        onClick={() => {
          console.log('[StepNavigation] Previous button clicked');
          onPrevious();
        }}
        disabled={isFirstStep}
        className={`
          inline-flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium text-sm
          transition-all duration-200
          ${
            isFirstStep
              ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
              : 'bg-white border border-slate-300 text-slate-700 hover:bg-slate-50 hover:border-slate-400 focus:outline-none focus:ring-2 focus:ring-[#00758d] focus:ring-offset-2'
          }
        `}
      >
        <ChevronLeft size={18} />
        <span>Précédent</span>
      </button>

      <button
        onClick={() => {
          console.log('[StepNavigation] Next button clicked');
          onNext();
        }}
        disabled={isLastStep}
        className={`
          inline-flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium text-sm
          transition-all duration-200
          ${
            isLastStep
              ? 'bg-slate-100 text-slate-400 cursor-not-allowed'
              : 'bg-[#00758d] text-white hover:bg-[#006374] shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#00758d] focus:ring-offset-2'
          }
        `}
      >
        <span>Suivant</span>
        <ChevronRight size={18} />
      </button>
    </div>
  );
};
